export const generateApplicationsData = (data: any) => {
  let rows: ApplicationData[] = [];
  data.forEach((r: any) => {
    const newRow: ApplicationData = {
      applicationId: r.id,
      applicantName: r?.params?.full_name,
      company_name: r?.params?.company_name,
      applicantEmail: r?.params?.email,
      businessEmail: r?.params?.business_email,
      date: r?.created_at,
      insurance: r?.products,
      status: r?.status,
    };
    rows.push(newRow);
  });
  return rows;
};

export const statusMapping: {
  [key: string]: { label: string; backgroundColor: string; color: string };
} = {
  incomplete: {
    label: "APPLICATION_PAGE.status.draft",
    backgroundColor: "#88C2D4",
    color: "#FFFFFF",
  },
  complete: {
    label: "APPLICATION_PAGE.status.submitted",
    backgroundColor: "#B9F6CA",
    color: "#00C853",
  },
};
